import React from 'react';
import AnswerCard from './AnswerCard.jsx';
import './analyticsAsk.css';

/** Pure render of a `comparison` result (groupComparison.js's runGroupComparison output) — two
 *  AnswerCards side by side, each under its server-authored `label`, plus the server's
 *  descriptive `note` VERBATIM below.
 *
 *  NEVER computes or renders a delta / percentage-difference figure between the two panels —
 *  descriptive-only is a product contract (groupComparison.js's own header): "Group X vs the
 *  rest" is two honest numbers, each with its OWN uncertainty, not a significance test.
 *  Computing a delta client-side — even just `primary.value - baseline.value` for display —
 *  would reintroduce the exact claim the backend deliberately avoids, by the back door. This
 *  component reads only `label`/`presentation`/`note` off its prop; it has no access to a raw
 *  numeric value to diff even by accident (AnswerCard's own presentation is string-formatted). */
export default function ComparisonCard({ comparison: c }) {
  if (!c) return null;
  return (
    <div className="aa-comparison">
      <div className="aa-comparison__panels">
        <div className="aa-comparison__panel">
          <div className="aa-comparison__label">{c.primary.label}</div>
          <AnswerCard presentation={c.primary.presentation} />
        </div>
        <div className="aa-comparison__panel">
          <div className="aa-comparison__label">{c.baseline.label}</div>
          <AnswerCard presentation={c.baseline.presentation} />
        </div>
      </div>
      {c.note && <p className="aa-comparison__note">{c.note}</p>}
    </div>
  );
}
